import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';
import { PeriodFormComponent } from '../../../components/periods/period-form/period-form.component';
import { InformationModalComponent } from '../../../components/information-modal/information-modal.component';
import { ApiService } from '../../../services/api.service';
import { QueueMessageDetailsComponent } from '../../../components/queue-message/client-details/queue-message-details.component';

@Component({
  selector: 'app-queue-messages-index',
  standalone: true,
  imports: [
    CommonModule,
    PeriodFormComponent,
    LoaderComponent,
    TableGuruComponent
  ],
  templateUrl: './queue-message-index.component.html',
  styleUrl: './queue-message-index.component.scss'
})
export class QueueMessageIndexComponent {
  items: [] = [];
  private modalService = inject(NgbModal);
  reloadItems: boolean = false;
  loading: boolean = false;

  editFormReference = PeriodFormComponent;
  viewReference = QueueMessageDetailsComponent;

  constructor(
    private apiService: ApiService
  ) { }

  openModal(item: any) {
    
  }

  sync () {
    let self = this;
    const modalRef = this.modalService.open(InformationModalComponent);
    modalRef.componentInstance.title = 'Syncen';
    modalRef.componentInstance.message = 'Wil je de queue verwerken?';
    modalRef.componentInstance.cancelButtonText = 'Annuleer';
    modalRef.componentInstance.confirmButtonText = 'Verwerken';
    modalRef.componentInstance.loader = false;
    modalRef.result.then((success) => {
      if (success) {
        self.loading = true;
        this.apiService.get("/office/queue-messages/sync", {
          mail_content: ''
        }).then(function (response: any) {
          self.loading = false;
          self.reloadItems = true;
        }).catch(function (e) {
          self.loading = false;
          self.reloadItems = true;
        });
      } else {

      }
    });
  }
}
